import type { Messages } from './messages.en';

export const es: Messages = {
  'home.title': "L'Infiltré",
  'home.subtitle': 'Crisis en el barrio. Elige un modo.',
  'home.resume.eyebrow': 'Reanudar',
  'home.resume.label': 'Continuar partida guardada',
  'home.standalone.eyebrow': 'Local',
  'home.standalone.label': 'Jugar en este dispositivo',
  'home.standalone.description': 'Funciona sin conexión. Un dispositivo, varios jugadores.',
  'home.online.eyebrow': 'En línea',
  'home.online.label': 'Sala privada',
  'home.online.description': 'Próximamente.',
  'home.version': 'v0.0.0',
  'home.players_minutes': '3–12 jugadores · 5 min / ronda',
  'home.eyebrow': 'Crisis · Infiltrados entre los Flics',
  'home.lede':
    'Los Flics comparten una palabra clave. Un Infiltré ve una palabra parecida — pero diferente. Descúbrelo antes de que te señale.',
  'home.tagline.same_word': 'Misma palabra clave. Casi.',
  'home.tagline.almost': 'Uno de vosotros está infiltrado.',
  'home.tagline.spot_the_imposter': 'Descubre al Infiltré.',
  'home.rules.cta': 'Cómo jugar',

  'rules.eyebrow': 'Briefing · 30 segundos',
  'rules.title': 'Cómo jugar',
  'rules.sub': 'Tres reglas. Un Infiltré. No te dejes pillar.',
  'rules.step1.title': 'Cada jugador recibe una palabra secreta.',
  'rules.step1.body':
    'Los Flics comparten una palabra clave. El Infiltré ve una palabra similar — pero diferente. El Clochard no ve nada: un vagabundo del barrio que solo intenta adivinar.',
  'rules.step2.title': 'Por turnos, describe tu palabra.',
  'rules.step2.body':
    'Una palabra, sin rimas ni deletreo. Los farsantes deben improvisar sin delatarse.',
  'rules.step3.title': 'Vota al Infiltré.',
  'rules.step3.body':
    'Tras las pistas, la mesa vota. Si eliminas al Clochard, tendrá una última oportunidad de adivinar la palabra de los Flics y robar la victoria.',
  'rules.footer': 'Ideal entre 4 y 8 amigos. Pasa el dispositivo. No te fíes de nadie.',
  'rules.got_it': 'Entendido',

  'setup.count.heading': '¿Cuántos jugadores?',
  'setup.count.hint': 'Toca el número y pasa el dispositivo',
  'setup.count.cta': 'Pasar el dispositivo al jugador 1',
  'setup.slot.player_label': 'Jugador {n}',
  'setup.slot.hint': 'Mantén pulsado para escribir tu nombre',
  'setup.slot.welcome': 'Escribe tu nombre',
  'setup.slot.name_placeholder': 'Tu nombre',
  'setup.slot.confirm': 'Confirmar — pasar el dispositivo',
  'setup.slot.duplicate_error': 'Este nombre ya está en uso.',

  'setup.players.heading': 'Jugadores',
  'setup.players.hint': 'Introduce a cada jugador. El primer nombre es el anfitrión.',
  'setup.players.host_placeholder': 'Nombre del anfitrión',
  'setup.players.player_placeholder': 'Jugador {index}',
  'setup.players.add': '+ Añadir jugador',
  'setup.players.duplicate_error': 'Los nombres deben ser únicos.',

  'setup.briefing.eyebrow': 'Preparación',
  'setup.briefing.title': 'Sala de briefing',
  'setup.briefing.settings': 'Ajustes',
  'setup.host_settings.title': 'Ajustes de la sala',
  'setup.host_settings.eyebrow': 'Controles del anfitrión · expediente',
  'setup.host_settings.hint': 'Configura la ronda antes de repartir. Solo el anfitrión lo ve.',
  'setup.host_settings.lock_in': 'Confirmar',
  'setup.host_settings.section.mode': 'Modo de juego',
  'setup.host_settings.section.roles': 'Roles',
  'setup.host_settings.section.pace': 'Ritmo',
  'setup.host_settings.section.word_pack': 'Pack de palabras',
  'setup.host_settings.infiltre_hint': 'Miente sobre una palabra similar',
  'setup.host_settings.clochard_label': 'Incluir Clochard',
  'setup.host_settings.clochard_hint':
    'Vagabundo del barrio. No sabe nada. Puede robar la victoria adivinando la palabra de los Flics.',
  'setup.host_settings.timer_hint': 'Segundos por ronda · 0 = sin temporizador',
  'setup.host_settings.timer_off': 'Off',
  'category.animals': 'Animales',
  'category.food': 'Comida',
  'category.objects': 'Objetos',
  'category.geography': 'Geografía',
  'category.nature': 'Naturaleza',
  'category.sports': 'Deportes',
  'category.movies': 'Películas',
  'category.slang': 'Argot',
  'setup.briefing.headline_top': 'Sala de',
  'setup.briefing.headline_bottom': 'briefing.',
  'setup.briefing.lede':
    'Recluta a tus sospechosos. Toca una polaroid para renombrar. Las palabras están selladas — incluso para el anfitrión.',
  'setup.briefing.recruit': 'Reclutar',
  'setup.briefing.suspects': 'Sospechosos',
  'setup.briefing.need_more': 'Recluta {needed} más',
  'setup.briefing.deal_cards': 'Empezar ronda',
  'setup.briefing.sealed_hint': 'Par de palabras sellado — nadie lo ve aún.',
  'setup.mugshot.customize_aria': 'Personalizar retrato',
  'setup.mugshot.title': 'Retrato robot',
  'setup.mugshot.phase': 'Ficha 01',
  'setup.mugshot.subtitle': 'identidad del sospechoso',
  'setup.mugshot.section.identity': 'Identidad',
  'setup.mugshot.section.features': 'Rasgos',
  'setup.mugshot.randomize': 'Aleatorio',
  'setup.mugshot.close': 'Cerrar',
  'setup.mugshot.done': 'Listo',
  'setup.mugshot.category.menton': 'Mentón',
  'setup.mugshot.category.nez': 'Nariz',
  'setup.mugshot.category.bouche': 'Boca',
  'setup.mugshot.category.moustache': 'Bigote',
  'setup.mugshot.category.yeux': 'Ojos',
  'setup.mugshot.category.sourcils': 'Cejas',
  'setup.mugshot.category.cheveux': 'Pelo',
  'setup.mugshot.category.accessoire': 'Accesorio',
  'setup.recruit.sealed_eyebrow': 'Sellado · no abrir',

  'setup.options.heading': 'Opciones',
  'setup.options.include_clochard': 'Incluir Clochard',
  'setup.options.discussion_seconds': 'Temporizador de debate',
  'setup.options.discussion_seconds_hint': 'Segundos antes de votar. 0 = manual.',
  'setup.options.locale': 'Idioma',

  'locale.en': 'English',
  'locale.fr': 'Français',
  'locale.es': 'Español',
  'locale.de': 'Deutsch',
  'locale.pt': 'Português',

  'setup.start': 'Empezar partida',

  'play.no_active_game': 'No hay partida activa.',
  'play.go_home': 'Volver al inicio',
  'play.connecting': 'Conectando…',
  'play.phase_label': 'Fase: {phase}',

  'play.privacy_gate.pass_to': 'Pasar a',
  'play.privacy_gate.hold_to_reveal': 'Mantén pulsado para revelar',
  'play.privacy_gate.tap_to_reveal': 'Toca para revelar',
  'play.privacy_gate.hold_to_see_word': 'Mantén pulsado para ver tu palabra',
  'play.privacy_gate.tap_to_see_word': 'Toca para ver tu palabra',
  'play.privacy_gate.hold_to_vote': 'Mantén pulsado para votar',
  'play.privacy_gate.done': 'Listo — pasa el dispositivo',
  'play.pass_device.eyebrow': 'Pasa el dispositivo a',
  'play.pass_device.dossier': 'Expediente · {n}/{total}',
  'play.pass_device.no_peeking': '— No mires. Las paredes oyen.',
  'play.pass_device.ready': 'Estoy listo',

  'play.handoff.all_done_eyebrow': 'Todos los jugadores listos',
  'play.handoff.all_revealed_title': 'Todos los jugadores preparados',
  'play.handoff.all_revealed_description': 'Hora de discutir. Hablad por turnos.',
  'play.handoff.continue': 'Continuar',
  'play.handoff.all_voted_title': 'Todos los votos registrados',
  'play.handoff.all_voted_description': 'Toca para revelar.',
  'play.handoff.reveal': 'Revelar',

  'pause.button': 'Pausa',
  'pause.eyebrow': 'En pausa · al margen',
  'pause.title': 'Toma aire.',
  'pause.sub': 'Reanuda o corta por lo sano.',
  'pause.resume.label': 'Reanudar',
  'pause.resume.sub': 'Vuelve a la acción.',
  'pause.rules.label': 'Cómo jugar',
  'pause.rules.sub': 'Repasa las reglas.',
  'pause.quit.label': 'Salir',
  'pause.quit.sub': 'Termina la partida. Ajustes guardados.',
  'pause.recap.label': 'Resumen',
  'pause.recap.sub': 'Mira el expediente.',

  'recap.eyebrow_between': 'Expediente · ronda cerrada',
  'recap.eyebrow_end': 'Expediente · completo',
  'recap.title_between': 'Resumen de la ronda',
  'recap.title_end': 'Cómo terminó',
  'recap.sub_between': 'Lo que pasó. Aprovéchalo o no.',
  'recap.sub_end': 'Cada ronda, cada eliminación, en orden.',
  'recap.empty': 'Aún no hay rondas — el expediente está vacío.',
  'recap.still_in_room': 'Aún en juego',
  'recap.eliminated_meta': 'Eliminado · {count} restantes',
  'recap.round_short': 'Rda',
  'recap.close': 'Cerrar',

  'round.your_role': 'Tu rol',
  'round.your_card': 'Tu carta',
  'round.your_word': 'Tu palabra',
  'round.no_word': 'Sin palabra',
  'round.no_word_hint': 'Improvisa con un farol.',

  'round.speaking.heading': 'Orden de palabra',
  'round.speaking.hint': 'Cada jugador da una pista por turnos. No digas la palabra directamente.',
  'round.speaking.ready_to_vote': 'Listos para votar',
  'round.speaking.order_eyebrow': 'EN ORDEN',
  'round.speaking.order_title': 'Alrededor de la mesa',

  'round.vote.eyebrow': '{name} — tu voto',
  'round.vote.heading': 'Atrapa al Infiltré',

  'round.result.eyebrow': 'Ronda cerrada',
  'round.result.complete_eyebrow': 'Expediente',
  'round.result.voted_out_eyebrow': 'Eliminado',
  'play.clochard.spotlight': 'Bajo los focos',
  'play.clochard.last_words': '{name}, últimas palabras.',
  'play.clochard.one_guess': 'Un intento',
  'round.result.cast_eyebrow': 'reparto revelado',
  'round.result.suspects_count': 'sospechosos',
  'round.result.win_team.flic': 'FLICS',
  'round.result.win_team.infiltre': 'INFILTRÉS',
  'round.result.win_team.clochard': 'CLOCHARD',
  'round.result.win_verb.flic': 'GANAN.',
  'round.result.win_verb.infiltre': 'GANAN.',
  'round.result.win_verb.clochard': 'GANA.',
  'round.result.sub_flic': '— la mesa lo olió.',
  'round.result.sub_infiltre': '— escondido a plena vista.',
  'round.result.sub_clochard': '— una jugada. Sangre fría.',
  'round.result.replay_cta': 'Jugar de nuevo',
  'round.result.new_dossier_cta': 'Nuevo expediente',
  'round.result.title': 'Resultado de la ronda',
  'round.result.title_finished': 'Partida terminada',
  'round.result.still_in': 'Aún en juego',
  'round.eliminated': 'Eliminado',
  'round.winner': 'Ganador',
  'round.case_closed': 'Caso cerrado',
  'round.flic_word': 'Palabra de los Flics',
  'round.infiltre_word': 'Palabra de los Infiltrés',
  'round.next_round': 'Siguiente ronda',
  'round.back_home': 'Volver al inicio',
  'round.result.view_case_log_one': 'Ver expediente · 1 ronda',
  'round.result.view_case_log_many': 'Ver expediente · {count} rondas',
  'round.rematch': 'Revancha',
  'round.replay.button': 'Jugar otra ronda',
  'round.replay.waiting': 'Esperando ({count}/{needed} listos)',
  'round.replay.requested': 'Has votado por continuar',
  'round.eliminate.heading': '¿A quién han votado?',
  'round.eliminate.eyebrow': 'Voto',
  'round.eliminate.host_hint': 'Anfitrión · toca al perdedor',
  'round.eliminate.subtitle': 'Voto en voz alta · en la mesa',
  'round.eliminate.body':
    'Cada jugador vivo señala a alguien, sin pensarlo. Cuenta las manos en la mesa — el anfitrión toca al perdedor.',
  'round.eliminate.cta_idle': 'Toca a un jugador',
  'round.eliminate.cta_picked': 'Eliminar a {name}',
  'round.speaking.rule_eyebrow': 'Regla de la ronda',
  'round.speaking.rule_line1': 'Una palabra.',
  'round.speaking.rule_line2': 'Sin repetir.',
  'round.discuss.heading': 'Debate',
  'round.discuss.eyebrow_calm': 'Habla · acusa · defiende',
  'round.discuss.eyebrow_danger': 'Se acaba el tiempo',
  'round.discuss.seconds_label': 'Segundos',
  'round.discuss.tick_calm.0': '«¿Quién farolea?»',
  'round.discuss.tick_calm.1': '«No me lo creo.»',
  'round.discuss.tick_calm.2': '«Demuéstralo.»',
  'round.discuss.tick_calm.3': '«Tú primero.»',
  'round.discuss.tick_hot.0': '«Se acabó.»',
  'round.discuss.tick_hot.1': '«Elige.»',
  'round.discuss.tick_hot.2': '«Decide.»',

  'play.clochard.title': 'Clochard atrapado',
  'play.clochard.description': '{name}, adivina la palabra de los Flics para ganar.',
  'play.clochard.placeholder': 'Tu propuesta',
  'play.clochard.submit': 'Enviar propuesta',

  'role.flic': 'Flic',
  'role.infiltre': 'Infiltré',
  'role.clochard': 'Clochard',

  'home.online_join.eyebrow': 'En línea',
  'home.online_join.label': 'Unirse',
  'home.online_join.description': '¿Tienes una invitación? Introduce el código.',

  'home.discord.eyebrow': 'Canal de voz · Activity',
  'home.discord.heading': 'Juega con tu canal',
  'home.discord.tagline': 'Todos en voz, un mismo expediente.',
  'home.discord.lede': 'Todos los del canal de voz entran al mismo expediente.',
  'home.discord.lede_named': 'Hola {name} — junta a todos en voz en el mismo expediente.',
  'home.discord.start_activity': 'Entrar a la sala de Activity',
  'home.discord.start_busy': 'Abriendo expediente…',
  'home.discord.join_with_code': 'Unirse a otra sala con un código',
  'home.discord.no_instance': 'Activity de Discord no detectada — reinicia la Activity.',
  'home.discord.sdk_failed': 'El SDK de Discord no pudo iniciarse. Reintenta.',
  'home.discord.sdk_retry': 'Reintentar',
  'home.discord.solo_label': 'Jugar en este dispositivo',
  'home.online.unavailable': 'Modo en línea no disponible — servidor inaccesible.',

  'online.create.eyebrow': 'Nuevo expediente',
  'online.create.heading': 'Crear una sala',
  'online.create.hint': 'Elige un nombre. Generaremos un código para compartir.',
  'online.create.name_placeholder': 'Tu nombre',
  'online.create.submit': 'Crear sala',
  'online.create.creating': 'Creando…',

  'online.join.eyebrow': 'Sala de briefing',
  'online.join.heading': 'Unirse a una sala',
  'online.join.hint': 'Introduce el código que te ha pasado tu amigo.',
  'online.join.name_placeholder': 'Tu nombre',
  'online.join.code_placeholder': 'CÓDIGO DE SALA',
  'online.join.submit': 'Unirse',
  'online.join.joining': 'Conectando…',

  'online.lobby.players': 'Jugadores',
  'online.lobby.briefing_room': 'Sala de informe',
  'online.lobby.host_badge': 'Anfitrión',
  'online.lobby.you_badge': 'tú',
  'online.lobby.reconnecting_badge': 'reconectando',
  'online.lobby.offline_badge': 'offline',
  'online.toast.room_not_found': 'Sala no encontrada',
  'online.toast.room_full': 'Sala llena',
  'online.toast.kicked_after_grace': 'Estuviste desconectado demasiado tiempo.',
  'online.toast.unauthorized': 'Sesión expirada',
  'online.toast.presence_online': '{name} se reconectó',
  'online.toast.presence_reconnecting': '{name} se está reconectando',
  'online.toast.presence_offline': '{name} se desconectó',
  'online.toast.server_error.actor_mismatch': 'Esa acción no es de tu sesión',
  'online.toast.server_error.unknown_player': 'Jugador no está en la sala',
  'online.toast.server_error.name_required': 'El nombre no puede estar vacío',
  'online.toast.server_error.invalid_message': 'Solicitud inválida',
  'online.toast.server_error.unauthorized': 'No autorizado',
  'online.toast.server_error.only_host': 'Solo el anfitrión puede hacer eso',
  'online.toast.server_error.wrong_phase': 'Acción demasiado tarde — la ronda avanzó',
  'online.toast.server_error.invalid_target': 'Objetivo inválido',
  'online.toast.server_error.not_your_guess': 'No es tu turno de adivinar',
  'online.toast.server_error.not_a_member': 'No estás en esta sala',
  'online.toast.server_error.not_enough_players': 'Faltan jugadores',
  'online.toast.server_error.too_many_players': 'Demasiados jugadores',
  'online.toast.server_error.room_already_exists': 'La sala ya existe',
  'online.toast.server_error.no_session': 'Sesión caducada — reconectando',
  'online.toast.server_error.create_via_rest': 'Crea la sala desde la página principal',
  'online.toast.server_error.system_only_message': 'Mensaje del sistema bloqueado',
  'online.toast.server_error.internal': 'Error inesperado del servidor',
  'online.toast.server_error.generic': 'Error del servidor: {message}',
  'online.lobby.waiting_host': 'Esperando que el anfitrión empiece…',
  'online.lobby.start_game': 'Empezar partida',
  'online.lobby.need_more_players': 'Hacen falta al menos 3 jugadores',

  'online.room.code_label': 'Código de la sala',
  'online.room.code_hide': 'Ocultar el código',
  'online.room.code_show': 'Mostrar el código',
  'online.room.copy': 'Copiar',
  'online.room.copied': '¡Copiado!',

  'online.banner.connecting': 'Reconectando…',
  'online.banner.error': 'Conexión perdida. Reintentando.',

  'online.reveal.acknowledge': 'Entendido',
  'online.reveal.waiting.eyebrow': 'FASE 01 · BRIEFING',
  'online.reveal.waiting.title': 'Briefing en curso',
  'online.reveal.waiting.descriptor': '— esperando a {pending} agente(s)',
  'online.reveal.waiting.center_label': 'listos',
  'online.discuss.host_open_vote_button': 'Listos para votar',
  'online.discuss.waiting_host': 'Esperando que el anfitrión abra la votación…',
  'online.discuss.timer_label': 'La votación abrirá en {time}',
  'online.discuss.timer_expired': 'Abriendo votación…',
  'online.discuss.timer_eyebrow': 'Votación en',
  'online.vote.spectating': 'Estás eliminado. Mirando la ronda.',
  'online.vote.waiting.eyebrow': 'FASE 03 · VOTO',
  'online.vote.waiting.title': 'Recuento de votos',
  'online.vote.waiting.descriptor': '— {pending} voto(s) pendiente(s)',
  'online.vote.waiting.center_label': 'votado',
  'online.clochard.spectating': '{name} se la juega.',
  'online.round.waiting_host': 'Esperando al anfitrión…',
  'online.spectator.heading': 'Espectador',
  'online.spectator.eyebrow': 'FUERA DEL JUEGO · OBSERVANDO',
  'online.spectator.eliminated': 'Estás fuera — mirando la ronda.',
  'online.spectator.finished': 'Partida terminada.',
  'online.spectator.flic_word': 'Palabra de los Flics',
  'online.spectator.infiltre_word': 'Palabra de los Infiltrés',
  'online.spectator.phase_label': 'Fase: {phase}',
  'online.host_changed.banner': '{name} es ahora el anfitrión.',
  'online.host_changed.you_banner': 'Ahora eres el anfitrión.',

  'platform.error.discord_unavailable': 'Las funciones de Discord no están disponibles aquí.',
  'platform.error.tauri_unavailable': 'Las funciones de escritorio no están disponibles aquí.',
  'platform.error.capacitor_unavailable': 'Las funciones móviles no están disponibles aquí.',
  'platform.error.identity_failed': 'No se pudo iniciar sesión. Inténtalo de nuevo.',
  'platform.banner.platform_label': 'Ejecutándose en {platform}',
  'platform.discord.connecting': 'Conectando con Discord…',
  'platform.discord.authorizing': 'Autorizando con Discord…',
  'platform.tauri.connecting': 'Cargando sesión…',
  'platform.capacitor.connecting': 'Cargando sesión…',
  'a11y.privacy_gate.aria_label': 'Mantén pulsado para revelar — pasa a {name}',
  'a11y.vote_board.candidate_aria_label': 'Votar a {name}',
  'a11y.audio.mute_label': 'Silenciar efectos de sonido',
  'a11y.audio.unmute_label': 'Activar efectos de sonido',
  'a11y.audio.volume_label': 'Volumen de efectos',

  'nav.brand': "L'Infiltré",
  'nav.back': 'Atrás',
  'nav.home_label': 'Volver al inicio',
  'nav.settings_label': 'Abrir ajustes',

  'settings.title': 'Ajustes',
  'settings.close': 'Cerrar',
  'settings.section.language': 'Idioma',
  'settings.language.subtitle': 'elige el idioma de la interfaz',
  'settings.section.theme': 'Tema',
  'settings.theme.noir': 'Noir',
  'settings.theme.party': 'Fiesta',
  'settings.section.layout': 'Disposición',
  'settings.layout.auto': 'Auto',
  'settings.layout.mobile': 'Móvil',
  'settings.layout.desktop': 'Escritorio',
  'settings.section.audio': 'Audio',
  'settings.audio.mute': 'Silenciar efectos',
  'settings.audio.volume': 'Volumen',

  'mode.select.heading': 'Elige un modo',
  'mode.select.hint': 'Elige cómo jugar. Puedes cambiarlo en los ajustes.',
  'mode.select.coming_soon': 'Próximamente',
  'mode.infiltre_classic.name': "L'Infiltré",
  'mode.infiltre_classic.tagline': 'Flics contra Infiltrés. Vota al que no encaja.',
  'mode.team_deathmatch.name': 'Combate por equipos',
  'mode.team_deathmatch.tagline': 'Dos equipos, dos palabras. Encuentra a los tuyos.',

  'briefing.phase_00': 'Fase 00 · Preparación',
  'briefing.title': 'Briefing',
  'briefing.subtitle': 'arregla la mesa antes de repartir',
  'briefing.mode.label': 'Modo — elige uno',
  'briefing.mode.classic': '1 Infiltrado · estándar',
  'briefing.mode.duo': '2 Infiltrados · 6+ jugadores',
  'briefing.mode.trio': '3 Infiltrados · 9+ jugadores',
  'briefing.mode.clochard': '+ Clochard · 5+ jugadores',
  'briefing.timer.label': 'Discusión · segundos',
  'briefing.clochard.label': 'Incluir un Clochard',
  'briefing.clochard.hint': '(jugador sin palabra)',
  'briefing.footer.ready': 'listo — {count} sospechosos',
  'briefing.footer.need_more': 'faltan {count} jugadores',
  'briefing.footer.deal': 'Repartir',
  'briefing.tape.briefing_room': 'Briefing room',
  'briefing.tape.how_to_play_l1': '¿cómo',
  'briefing.tape.how_to_play_l2': 'jugar?',

  'round.distribution.phase_eyebrow': 'FASE 01 · REPARTO',
  'round.distribution.title': 'Reparto',
  'round.distribution.descriptor': '— {step} de {total}',
  'round.distribution.tour': 'TURNO',
  'round.distribution.no_peeking_tape': 'NO MIRES',
  'round.dossier.phase_eyebrow': 'FASE 01 · EXPEDIENTE PERSONAL',
  'round.dossier.title': 'Expediente',
  'round.dossier.descriptor': '— mantén el dedo para leer',
  'round.dossier.field_name': 'NOMBRE',
  'round.dossier.field_role': 'ROL',
  'round.dossier.field_word': 'PALABRA CLAVE',
  'round.dossier.release_to_hide': '— suelta para ocultar',
  'round.dossier.close_cta': 'CERRAR EXPEDIENTE',
  'round.speaking.phase_eyebrow': 'FASE 02 · TURNO DE HABLA',
  'round.speaking.descriptor': '— una palabra, en voz alta, en orden',
  'round.discuss.phase_eyebrow': 'FASE 03 · DEBATE ABIERTO',
  'round.discuss.title': 'Debate',
  'round.discuss.descriptor': '— ¿quién miente? hablen en voz alta.',
  'round.discuss.timer_eyebrow': 'CRONÓMETRO · TIEMPO RESTANTE',
  'round.discuss.timer_calm_sub': '— tómate tu tiempo',
  'round.discuss.timer_danger_sub': '— se acaba el tiempo',
  'round.discuss.suspects_pill': '{count} sospechosos en juego',
  'round.vote.phase_eyebrow': 'FASE 04 · VOTACIÓN A LA MESA',
  'round.vote.title': 'Voto',
  'round.vote.descriptor': '— voten en voz alta, marquen al eliminado',
  'round.verdict.phase_eyebrow': 'FASE 05 · VEREDICTO',
  'round.verdict.descriptor': '— el sospechoso cae',
  'round.verdict.role_revealed': 'ROL REVELADO',
  'round.verdict.role_tagline.flic': 'palabra real · inocente',
  'round.verdict.role_tagline.infiltre': 'palabra falsa · culpable',
  'round.verdict.role_tagline.clochard': 'sin palabra · comodín',
  'round.verdict.stamp': 'ELIMINADO',
  'round.verdict.no_elimination.title': 'Sin veredicto',
  'round.verdict.no_elimination.stamp': 'EXPEDIENTE APLAZADO',
  'round.verdict.no_elimination.descriptor': '— votos divididos, la partida continúa',
  'round.verdict.no_elimination.still_in': 'Aún en juego',
};
